import { isDefined } from "@clipboard-health/util-ts";
import { Chip } from "@mui/material";

import { placementApplicationStatusMap } from "../types/fetchPlacementApplications.schema";
import { type PlacementApplicationStatus } from "../types/placementApplicationStatus";

export interface PlacementApplicationStatusChipProps {
  status: PlacementApplicationStatus;
  size?: "small" | "medium";
  variant?: "outlined" | "filled";
}

export function PlacementApplicationStatusChip(props: PlacementApplicationStatusChipProps) {
  const { status, size = "small", variant = "outlined" } = props;
  const statusInfo = placementApplicationStatusMap[status];

  if (!isDefined(statusInfo)) {
    return null;
  }

  return (
    <Chip
      size={size}
      variant={variant}
      label={statusInfo.label}
      color={statusInfo.color}
      sx={(theme) => ({
        borderRadius: theme.shape.borderRadius / 2,
        height: theme.spacing(4),
        px: theme.spacing(1),
        width: "max-content",
        fontWeight: 400,
      })}
    />
  );
}
